.task-list {
  padding-left: 0;
}

.task-item {
  margin-top: 8px;
  min-height: 20px;
  display: flex;
  align-items: center;
}
.task-item.locked {
  cursor: not-allowed;
}
.task-item.completed .icon-wrapper {
  color: var(--color-dark-green);
}
.task-item .icon-wrapper {
  color: var(--color-gray);
  width: 28px;
}
.task-item a {
  color: inherit;
}

.task-title {
  flex: 1 1 auto;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9Db21jYXN0LXhmaW5pdHl4Y2hhbmdlMi9kbGUtd2ViYXBwL3NyYy9jb250YWluZXJzL01pc3Npb25Nb2RhbC9NaXNzaW9uRGV0YWlscyIsInNvdXJjZXMiOlsiVGFza0xpc3QubW9kdWxlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFOztBQUlBO0VBQ0U7O0FBSUo7RUFDRTtFQUNBOztBQUdGO0VBQ0U7OztBQUlKO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIudGFzay1saXN0IHtcbiAgcGFkZGluZy1sZWZ0OiAwO1xufVxuXG4udGFzay1pdGVtIHtcbiAgbWFyZ2luLXRvcDogOHB4O1xuICBtaW4taGVpZ2h0OiAyMHB4O1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuXG4gICYubG9ja2VkIHtcbiAgICBjdXJzb3I6IG5vdC1hbGxvd2VkO1xuICB9XG5cbiAgJi5jb21wbGV0ZWQge1xuICAgIC5pY29uLXdyYXBwZXIge1xuICAgICAgY29sb3I6IHZhcigtLWNvbG9yLWRhcmstZ3JlZW4pO1xuICAgIH1cbiAgfVxuXG4gIC5pY29uLXdyYXBwZXIge1xuICAgIGNvbG9yOiB2YXIoLS1jb2xvci1ncmF5KTtcbiAgICB3aWR0aDogMjhweDtcbiAgfVxuXG4gIGEge1xuICAgIGNvbG9yOiBpbmhlcml0O1xuICB9XG59XG5cbi50YXNrLXRpdGxlIHtcbiAgZmxleDogMSAxIGF1dG87XG59XG4iXX0= */